import React, { ReactElement } from 'react';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';


// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData } from '../../../SsapTypes';

interface IAutoReEnrollmentAttestation {
    actions: {
        onFieldChange_data: Function,
    },
    data: SsapData,
    formName: string,
    isAsteriskShown: boolean
}

const AutoReEnrollmentAttestation = (props: IAutoReEnrollmentAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                turquoiseConsent
            }
        },
        formName,
        isAsteriskShown = true
    } = props;

    return (
        <UniversalInput
            legend = { {
                legendText: 'ssap.input.legend.re_enrollment_consent'
            }}
            label = { {
                showRequiredIcon: isAsteriskShown
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.RADIO_BUTTONS,
                name: 'turquoiseConsent',
                value: turquoiseConsent,
                options: DROPDOWN_OPTIONS.RE_ENROLLMENT_CONSENT,
                validationType: VALIDATION_TYPES.CHOSEN,
                currentData: data,
                fields: [ 'legalAttestations' ]
            }}
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
            errorClasses = { [ 'margin-l-0' ] }
        />
    );
};

export default AutoReEnrollmentAttestation;